import { render, staticRenderFns } from "./gridgroup.vue?vue&type=template&id=c8beb680&scoped=true&"
import script from "./gridgroup.vue?vue&type=script&lang=js&"
export * from "./gridgroup.vue?vue&type=script&lang=js&"
import style0 from "./gridgroup.vue?vue&type=style&index=0&id=c8beb680&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8beb680",
  null
  
)

export default component.exports